import React from 'react';
import GlobalBeautyTechForum from './index';
import {Route} from 'react-router-dom';

export default [
  // FIXME: :gbtfLang? now matches any value (was a fra/enu/jpn enum); invalid-value behavior pending demo verification
  <Route
    key="/business/global-beauty-tech-forum/lang"
    path="business/global-beauty-tech-forum/:gbtfLang?"
    element={<GlobalBeautyTechForum />}
  />,
  <Route
    key="/business/global-beauty-tech-forum/course"
    path="business/global-beauty-tech-forum/:courseKey"
    element={<GlobalBeautyTechForum />}
  />,
];
